import { useEffect, useRef } from 'react';
import type { MapRef } from 'react-map-gl';
import { MapLocation } from '@/types/location';

interface MapboxFocusControllerProps {
  focusedLocation: MapLocation | null;
  isMobile: boolean;
  mapRef: React.RefObject<MapRef>;
}

export const MapboxFocusController = ({ focusedLocation, isMobile, mapRef }: MapboxFocusControllerProps) => {
  const previousLocationId = useRef<number | null>(null);

  useEffect(() => {
    if (!focusedLocation || focusedLocation.id === previousLocationId.current) return;
    previousLocationId.current = focusedLocation.id;

    const map = mapRef.current?.getMap();
    if (!map) return;

    // coordinates are [lat, lng], Mapbox needs [lng, lat]
    const lng = focusedLocation.coordinates[1];
    const lat = focusedLocation.coordinates[0];

    map.flyTo({
      center: [lng, lat],
      zoom: 15,
      pitch: 50,
      offset: isMobile ? [0, -Math.round((map.getContainer().clientHeight || 400) * 0.22)] as [number, number] : [0, 0] as [number, number],
      duration: 1200,
      essential: true,
    });
  }, [focusedLocation, isMobile, mapRef]);

  return null;
};
